import React from 'react'
import {
  TextInput,
} from 'react-admin'
import { Box, Typography } from '@material-ui/core'
import {
  formInputOptions,
} from '../../util/component-options'
import { useFormStyles } from '../../../styles'
import { useLabel, useTranslateResource } from '../../../hooks'
import { Form, getValidator } from '../../form'



const MaterialsForm = props => {
  const formClasses = useFormStyles(props)
  const label = useLabel(props)
  const translate = useTranslateResource(props.resource)

  return (
    <Form
      {...props}
    >
      <Typography className={formClasses.noteText}>
        {translate('form.info.noteText')}
      </Typography>
      <Box className={formClasses.grid}>
        <Box>
          <TextInput
            {...formInputOptions}
            source='name'
            label={label('name')}
            validate={getValidator()}
            required
            disabled={props.isUpdateDisabled}
          />
        </Box>
      </Box>
    </Form>
  )
}

export default MaterialsForm
